import React, {ReactNode} from "react";
import {I18nGlobals} from "../../../../shared/translation/i18nInterface";
import Parameter from "../../../dialog/parameter/Parameter";
import {
	ToolboxAnnotationAnnotation,
	ToolboxFormsForms
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import AnnotationCircleFunction from "./annotation/AnnotationCircleFunction";
import {PortalGlobals} from "../../../Portal";
import AnnotationSquareFunction from "./annotation/AnnotationSquareFunction";
import AnnotationLineFunction from "./annotation/AnnotationLineFunction";
import AnnotationMarkFunction from "./annotation/AnnotationMarkFunction";
import AnnotationUnderlineFunction from "./annotation/AnnotationUnderlineFunction";
import AnnotationSquigglyFunction from "./annotation/AnnotationSquigglyFunction";
import AnnotationStrikeFunction from "./annotation/AnnotationStrikeFunction";
import AnnotationNoteFunction from "./annotation/AnnotationNoteFunction";
import RedactAreaFunction from "./redact/RedactAreaFunction";
import RedactTextFunction from "./redact/RedactTextFunction";
import AnnotationReplyFunction from "./annotation/AnnotationReplyFunction";
import AnnotationStampFunction from "./annotation/AnnotationStampFunction";
import {PortalToolboxAnnotationAnnotation} from "../../../../shared/models/PortalToolboxAnnotationAnnotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";
import {DebugGlobals} from "../../../dialog/components/settings/DebugDialog";
import {HelperGlobals} from "../../../../shared/components/Helper";
import {FormLayerGlobals} from "../../../viewer/pdf/form/FormLayerInterface";
import PortalPureComponent from "../../../../shared/components/PortalPureComponent";

export interface SidebarFunctionGlobals {
	showAnnotationLineFunction: boolean;
	annotationLineParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationCircleFunction: boolean;
	annotationCircleParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationSquareFunction: boolean;
	annotationSquareParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationMarkFunction: boolean;
	annotationMarkParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationUnderlineFunction: boolean;
	annotationUnderlineParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationSquigglyFunction: boolean;
	annotationSquigglyParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationStrikeFunction: boolean;
	annotationStrikeParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationNoteFunction: boolean;
	annotationNoteParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showRedactAreaFunction: boolean;
	redactAreaParameter?: Parameter<PortalToolboxAnnotationAnnotation>;
	showRedactTextFunction: boolean;
	redactTextParameter?: Parameter<PortalToolboxAnnotationAnnotation>;
	showAnnotationReplyFunction: boolean;
	annotationReplyParameter?: Parameter<ToolboxAnnotationAnnotation>;
	showAnnotationStampFunction: boolean;
	annotationStampParameter?: Parameter<PortalToolboxAnnotationAnnotation>;
	updateSidebarFunction: number;
	showFormsEditFunction: boolean;
	formsEditFunctionParameter?: Parameter<ToolboxFormsForms>;
}

export function initSidebarFunctionGlobals(): SidebarFunctionGlobals {
	return {
		updateSidebarFunction: Date.now(),
		showAnnotationLineFunction: false,
		showAnnotationCircleFunction: false,
		showAnnotationSquareFunction: false,
		showAnnotationMarkFunction: false,
		showAnnotationUnderlineFunction: false,
		showAnnotationSquigglyFunction: false,
		showAnnotationStrikeFunction: false,
		showAnnotationNoteFunction: false,
		showRedactAreaFunction: false,
		showRedactTextFunction: false,
		showAnnotationReplyFunction: false,
		showAnnotationStampFunction: false,
		showFormsEditFunction: false
	};
}

interface SidebarFunctionsProperties extends SidebarFunctionGlobals, I18nGlobals, PortalGlobals, DebugGlobals,
	HelperGlobals, FormLayerGlobals {
}

export default class SidebarFunctions extends PortalPureComponent<SidebarFunctionsProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<>
				{FunctionHelper.applyValue(this.props.showAnnotationLineFunction, false) &&
					<AnnotationLineFunction {...this.props}
											visible={FunctionHelper.applyValue(
												this.props.showAnnotationLineFunction, false
											)}
											hide={() => this.props.context.getPage().setState({
												showAnnotationLineFunction: false
											})}
											parameter={this.props.annotationLineParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationSquareFunction, false) &&
					<AnnotationSquareFunction {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showAnnotationSquareFunction, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showAnnotationSquareFunction: false
											  })}
											  parameter={this.props.annotationSquareParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationCircleFunction, false) &&
					<AnnotationCircleFunction {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showAnnotationCircleFunction, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showAnnotationCircleFunction: false
											  })}
											  parameter={this.props.annotationCircleParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationMarkFunction, false) &&
					<AnnotationMarkFunction {...this.props}
											visible={FunctionHelper.applyValue(
												this.props.showAnnotationMarkFunction, false
											)}
											hide={() => this.props.context.getPage().setState({
												showAnnotationMarkFunction: false
											})}
											updated={this.props.updateSidebarFunction}
											parameter={this.props.annotationMarkParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationUnderlineFunction, false) &&
					<AnnotationUnderlineFunction {...this.props}

												 visible={FunctionHelper.applyValue(
													 this.props.showAnnotationUnderlineFunction, false
												 )}
												 hide={() => this.props.context.getPage().setState({
													 showAnnotationUnderlineFunction: false
												 })}
												 updated={this.props.updateSidebarFunction}
												 parameter={this.props.annotationUnderlineParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationSquigglyFunction, false) &&
					<AnnotationSquigglyFunction {...this.props}

												visible={FunctionHelper.applyValue(
													this.props.showAnnotationSquigglyFunction, false
												)}
												hide={() => this.props.context.getPage().setState({
													showAnnotationSquigglyFunction: false
												})}
												updated={this.props.updateSidebarFunction}
												parameter={this.props.annotationSquigglyParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationStrikeFunction, false) &&
					<AnnotationStrikeFunction {...this.props}
											  visible={FunctionHelper.applyValue(
												  this.props.showAnnotationStrikeFunction, false
											  )}
											  hide={() => this.props.context.getPage().setState({
												  showAnnotationStrikeFunction: false
											  })}
											  updated={this.props.updateSidebarFunction}
											  parameter={this.props.annotationStrikeParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationNoteFunction, false) &&
					<AnnotationNoteFunction {...this.props}
											visible={FunctionHelper.applyValue(
												this.props.showAnnotationNoteFunction, false
											)}
											hide={() => this.props.context.getPage().setState({
												showAnnotationNoteFunction: false
											})}
											parameter={this.props.annotationNoteParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showRedactAreaFunction, false) &&
					<RedactAreaFunction {...this.props}
										visible={FunctionHelper.applyValue(
											this.props.showRedactAreaFunction, false
										)}
										hide={() => this.props.context.getPage().setState({
											showRedactAreaFunction: false
										})}
										parameter={this.props.redactAreaParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showRedactTextFunction, false) &&
					<RedactTextFunction {...this.props}
										visible={FunctionHelper.applyValue(
											this.props.showRedactTextFunction, false
										)}
										hide={() => this.props.context.getPage().setState({
											showRedactTextFunction: false
										})}
										updated={this.props.updateSidebarFunction}
										parameter={this.props.redactTextParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationReplyFunction, false) &&
					<AnnotationReplyFunction {...this.props}
											 visible={FunctionHelper.applyValue(
												 this.props.showAnnotationReplyFunction, false
											 )}
											 hide={() => this.props.context.getPage().setState({
												 showAnnotationReplyFunction: false
											 })}
											 parameter={this.props.annotationReplyParameter}/>
				}
				{FunctionHelper.applyValue(this.props.showAnnotationStampFunction, false) &&
					<AnnotationStampFunction {...this.props}
											 visible={FunctionHelper.applyValue(
												 this.props.showAnnotationStampFunction, false
											 )}
											 hide={() => this.props.context.getPage().setState({
												 showAnnotationStampFunction: false
											 })}
											 parameter={this.props.annotationStampParameter}/>
				}
			</>
		);
	}
}